import intlMessagesEN from './i18n/localization/en.json';
import intlMessagesVi from './i18n/localization/vi.json';

export default {
  name: 'DynamicFormRegisterIEC',
  dir: 'DynamicFormRegisterIEC',
  pathRoot: 'iec-dang-ky-su-kien',
  routes: [
    {
      url: ':slug',
      component: 'Page',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Đăng ký sự kiện | Smart Event',
        titleI18n: 'DynamicFormRegisterIEC:title',
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: 'Any',
};
